module.exports = __webpack_public_path__ + "img/agma2001-D04_fig08.bb163b28.png";